"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Handle = /** @class */ (function (_super) {
    __extends(Handle, _super);
    function Handle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            clickFocused: false
        };
        _this.genStyles = function () {
            var _a;
            var _b = _this.props, style = _b.style, vertical = _b.vertical, offset = _b.offset;
            var position = vertical ? 'bottom' : 'left';
            var styles = __assign(__assign({}, style), (_a = {}, _a[position] = offset + "%", _a));
            return styles;
        };
        _this.genTabIndex = function () {
            var _a = _this.props, disabled = _a.disabled, tabIndex = _a.tabIndex;
            var index;
            if (disabled || tabIndex === null) {
                index = undefined;
            }
            else {
                index = tabIndex || 0;
            }
            return index;
        };
        _this.setHandleRef = function (node) {
            _this.handle = node;
        };
        _this.setClickFocus = function (focused) {
            _this.setState({ clickFocused: focused });
        };
        _this.handleMouseUp = function () {
            if (document.activeElement === _this.handle) {
                _this.setClickFocus(true);
            }
        };
        _this.handleMouseDown = function () {
            _this.handle.focus();
        };
        _this.handleBlur = function () {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function () {
            _this.setClickFocus(false);
        };
        _this.genClasses = function () {
            var prefixCls = _this.props.prefixCls;
            var classes = 'rc-slider-handle';
            if (_this.state.clickFocused) {
                classes += " " + prefixCls + "-handle-click-focused";
            }
            return classes;
        };
        return _this;
    }
    Handle.prototype.componentDidMount = function () {
        document.addEventListener('mouseup', this.handleMouseUp);
    };
    Handle.prototype.componentWillUnmount = function () {
        document.removeEventListener('mouseup', this.handleMouseUp);
    };
    Handle.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, min = _a.min, max = _a.max, value = _a.value, children = _a.children;
        return (React.createElement("div", { ref: this.setHandleRef, tabIndex: this.genTabIndex(), className: this.genClasses(), style: this.genStyles(), onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, "aria-disabled": !!disabled }, children));
    };
    Handle.defaultProps = {
        style: {}
    };
    return Handle;
}(react_1.Component));
exports.default = Handle;
